/* eslint-disable react/self-closing-comp */
/* eslint-disable arrow-body-style */
import React, { FC } from 'react';
import { linkAnalysisResultsApi } from '../../mothership/linkAnalysisResults.state';

interface Props {
  id: string;
}

export const ResultsGraph: FC<Props> = ({ id }) => (
  <div
    key={`${id}GraphContainer`}
    ref={linkAnalysisResultsApi.setGraphContainer}
    id="linkAnalysisGraphContainer"
  ></div>
);
